var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:recent"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.25 6.66667H9.99998V10.8333L13.5666 12.95L14.1666 11.9417L11.25 10.2083V6.66667ZM10.8333 2.5C8.84419 2.5 6.93653 3.29018 5.53001 4.6967C4.12349 6.10322 3.33331 8.01088 3.33331 10H0.833313L4.13331 13.3583L7.49998 10H4.99998C4.99998 8.4529 5.61456 6.96917 6.70852 5.87521C7.80249 4.78125 9.28622 4.16667 10.8333 4.16667C12.3804 4.16667 13.8641 4.78125 14.9581 5.87521C16.0521 6.96917 16.6666 8.4529 16.6666 10C16.6666 11.5471 16.0521 13.0308 14.9581 14.1248C13.8641 15.2188 12.3804 15.8333 10.8333 15.8333C9.22498 15.8333 7.76665 15.175 6.71665 14.1167L5.53331 15.3C6.22621 16.0005 7.05179 16.5559 7.96181 16.9336C8.87183 17.3114 9.84802 17.5039 10.8333 17.5C12.8224 17.5 14.7301 16.7098 16.1366 15.3033C17.5431 13.8968 18.3333 11.9891 18.3333 10C18.3333 8.01088 17.5431 6.10322 16.1366 4.6967C14.7301 3.29018 12.8224 2.5 10.8333 2.5Z",
    fill: "#888D99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.24ea297ff90e3801c21599cddac26c7d.svg";
export { ForwardRef as ReactComponent };